module.exports = __webpack_public_path__ + "img/htkj_00.9c8d369a.jpg";